import React from 'react';
import { getIntentTone } from './intentTone';

export default function DiagnosticScoreCard({ diagnosticScore, intent }) {
  if (!diagnosticScore || typeof diagnosticScore !== 'object') return null;
  const tone = getIntentTone(intent);
  const value = diagnosticScore.score_value;
  const threshold = diagnosticScore.score_threshold;
  const zones = Array.isArray(diagnosticScore.score_zones) ? diagnosticScore.score_zones : [];
  const signals = Array.isArray(diagnosticScore.contributing_signals) ? diagnosticScore.contributing_signals : [];
  const pct = typeof value === 'number' ? Math.max(0, Math.min(1, value)) : null;
  const meets = typeof value === 'number' && typeof threshold === 'number' ? value >= threshold : null;

  return (
    <div className="mt-3 rounded-xl border border-white/10 bg-white/5 px-4 py-3">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-xs tracking-wide text-white/60 font-semibold">{diagnosticScore.score_label || 'Diagnóstico'}</div>
          <div className="mt-0.5 text-[11px] text-white/55">
            {diagnosticScore.score_key ? `Score: ${String(diagnosticScore.score_key)}` : 'Score'}
          </div>
        </div>
        {meets != null ? (
          <span
            className="shrink-0 inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold whitespace-nowrap"
            style={{
              background: meets ? 'rgba(16,185,129,0.16)' : 'rgba(244,63,94,0.16)',
              borderColor: meets ? 'rgba(52,211,153,0.30)' : 'rgba(251,113,133,0.30)',
              color: meets ? 'rgba(209,250,229,0.95)' : 'rgba(255,241,242,0.95)',
            }}
          >
            {meets ? 'OK' : 'Bajo'}
          </span>
        ) : null}
      </div>

      {pct != null ? (
        <div className="mt-3">
          <div className="relative h-[8px] rounded-full bg-white/10 overflow-hidden">
            <div className="h-full" style={{ width: `${pct * 100}%`, background: tone.fill }} aria-hidden="true" />
            {typeof threshold === 'number' ? (
              <div
                className="absolute w-[2px] bg-white/70"
                style={{ left: `${Math.max(0, Math.min(1, threshold)) * 100}%`, top: '-2px', bottom: '-2px' }}
                aria-hidden="true"
              />
            ) : null}
          </div>
          <div className="mt-2 flex items-center justify-between text-[11px] text-white/60">
            <span className="tabular-nums">{typeof value === 'number' ? value.toFixed(2) : '—'}</span>
            <span className="tabular-nums">Umbral {typeof threshold === 'number' ? threshold.toFixed(2) : '—'}</span>
          </div>
          {zones.length ? (
            <div className="mt-2 flex flex-wrap gap-2">
              {zones.slice(0, 4).map((z, idx) => (
                <span key={`${z.label}-${idx}`} className="inline-flex items-center rounded-full border border-white/10 bg-white/5 px-2 py-0.5 text-[10px] font-semibold text-white/70">
                  {String(z.label)}
                </span>
              ))}
            </div>
          ) : null}
        </div>
      ) : null}

      {signals.length ? (
        <div className="mt-3">
          <div className="text-[10px] uppercase tracking-wider text-white/45">Señales</div>
          <div className="mt-2 space-y-1.5">
            {signals.slice(0, 5).map((s, idx) => (
              <div key={`${s.label}-${idx}`} className="flex items-center justify-between gap-3 rounded-md border border-white/10 bg-white/5 px-2.5 py-2">
                <div className="text-[11px] text-white/80 truncate" title={s.label}>{String(s.label || 'Señal')}</div>
                <div className="text-[11px] font-semibold tabular-nums text-white/65">
                  {s.weight != null ? `${Math.round(Number(s.weight) * 100)}%` : '—'}
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
